export default function NotFound() {
  return (
    <div className="page-center">
      <div>
        <h2>Page introuvable</h2>
        <p>Vérifiez l'adresse et réessayez.</p>
      </div>
    </div>
  );
}
